export default "__VITE_ASSET__102e557a__"